import { Input as AntInput } from 'antd';
import { TextAreaProps } from 'antd/lib/input/TextArea';
import React from 'react';

import cn from 'classnames';
import styles from './Input.module.scss';

const { TextArea: AntInputTextArea } = AntInput;

export interface IInputTextAreaProps extends TextAreaProps {}

/**
 * Input TextArea component
 */
export const TextArea: React.FC<IInputTextAreaProps> = ({
  className,
  ...restProps
}) => (
  <AntInputTextArea className={cn(styles.TextArea, className)} {...restProps} />
);
